// extracted by mini-css-extract-plugin
module.exports = {"Feedback":"Feedback_Feedback__i3TLj"};